import React from 'react';
import PropTypes, { any } from 'prop-types';
import config from '../../../config';

import styles from './eventRegForm.scss';
import CampConfirmationCard from './CampConfirmationCard';
import InfoButton from '../InfoButton';
import { regStepIds, registrationUserOptions } from '../../utils/eventConstants';
import { trackEvent } from '../Analytics/TrackedClick';

const CampConfirmation = ({
    memberId,
    event,
    multipleDivisionRegistrations,
    toStep,
}) => {
  const currencySymbol = event?.currency?.symbol || '$';

  const handleContinue = () => {
    trackEvent('Selections Confirmed', {
      memberId,
      eventId: event?.id,
      registrationType: registrationUserOptions.MULTIPLE_PLAYERS,
    });

    toStep(regStepIds.PAYMENT);
  };

  const divisionsFee = Object.values(multipleDivisionRegistrations).reduce((acc, { price }) => acc + price, 0);
  const serviceFee = event?.serviceFee || 0;
  const displayServiceFee = serviceFee > 0;
  const total = divisionsFee + serviceFee;

  return (
      <div className="row">
          <div className="col">
              <div className={styles.confirmationWrapper}>
                  {event.eventDivisions
                    .filter((division) => multipleDivisionRegistrations[division.id]?.quantity > 0) // Filter divisions that were selected in the previous process
                    .map((division) => (
                        <CampConfirmationCard
                            key={division.id}
                            division={division}
                            event={event}
                            currentRegistration={multipleDivisionRegistrations[division.id] || {}}
                            currencySymbol={currencySymbol}
                        />
                ))}
                  <div className="col">
                      <div>
                          <div className="mt32 mb24">
                              <div className="mt4">
                                Subtotal: <span className="float-right"> {currencySymbol}{divisionsFee?.toFixed(2)}</span>
                              </div>
                              {displayServiceFee && (
                              <div className="mt4">
                                Service Fee:<InfoButton fixedWidth={250} hoverText={`These fees support the essential costs we incur in critical areas like new features, security, reliability/performance, trust and safety and support.`} /> <span className="float-right">{currencySymbol}{serviceFee?.toFixed(2)}</span>
                              </div>
                              )}
                              <div className="mt4 text-black">
                                Total:<span className="float-right">{currencySymbol}{total?.toFixed(2)}</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div>
              <p className={`text text-small mb24 ${styles.termAndConditions}`}>
                UTR Sports is committed to making pickleball and tennis more
                accessible, fun, and cost-effective. UTR Sports does not screen event
                organizers or facilities for safety, and we encourage all players to
                register only if you know the organizer and facility. Juniors should
                be accompanied by an adult for the entire event.
              </p>

              <button
                  type="button"
                  className="btn btn-primary btn-xl btn-block text-uppercase mb24"
                  onClick={handleContinue}
              >
                AGREE & SUBMIT
              </button>
              <div className={styles.termAndConditions}>
                  <span>
                    By registering, I agree to UTR Sports’s{' '}
                      <a
                          href={`${config.marketingAppHost}/tos`}
                          target="_blank"
                          rel="noopener noreferrer"
                      >
                        terms of service
                      </a>{' '}
                    and any additional terms provided by the event organizer in the
                    event description. I also agree to provide my contact info to the
                    event organizer solely for the purpose of participating in this
                    event.
                  </span>
              </div>
          </div>
      </div>
);
};

CampConfirmation.propTypes = {
  memberId: PropTypes.number.isRequired,
  event: PropTypes.objectOf(any).isRequired,
  toStep: PropTypes.func.isRequired,
  multipleDivisionRegistrations: PropTypes.objectOf(any).isRequired,
};

export default CampConfirmation;
